(function () {
  const sections = document.querySelectorAll(".base-compare-table");
  for (const section of sections) {
    init(section);
  }
  /**
   * @param {HTMLElement} section
   */
  function init(section) {
    const scrollContainer = section.querySelector("[data-scroll-container]");
    const prevButton = section.querySelector("[data-prev-button]");
    const nextButton = section.querySelector("[data-next-button]");
    const swipeHeading = section.querySelector(".heading--swipe");
    prevButton.addEventListener("click", () => {
      const left = scrollContainer.scrollLeft;
      scrollContainer.scrollTo({
        left: left - 200,
        behavior: "smooth",
      });
    });
    nextButton.addEventListener("click", () => {
      const left = scrollContainer.scrollLeft;
      scrollContainer.scrollTo({
        left: left + 200,
        behavior: "smooth",
      });
    });
    function reloadButton() {
      if (scrollContainer.clientWidth == scrollContainer.scrollWidth) {
        prevButton.classList.add("hide");
        nextButton.classList.add("hide");
        swipeHeading.classList.add("hide");
      } else {
        prevButton.classList.remove("hide");
        nextButton.classList.remove("hide");
        swipeHeading.classList.remove("hide");
      }

      if (scrollContainer.scrollLeft == 0) {
        prevButton.classList.add("disabled");
        nextButton.classList.remove("disabled");
      } else if (
        scrollContainer.scrollLeft + scrollContainer.clientWidth >=
        scrollContainer.scrollWidth
      ) {
        prevButton.classList.remove("disabled");
        nextButton.classList.add("disabled");
      } else {
        prevButton.classList.remove("disabled");
        nextButton.classList.remove("disabled");
      }
    }
    reloadButton();
    scrollContainer.addEventListener("scroll", reloadButton);
    window.addEventListener("resize", reloadButton);
  }
})();
